import { Box, Card, CardHeader, Stack } from '@mui/material';
import { useAuthContext } from '../../../../context/AuthContext';
import { decrypt } from '../../../../utils/cryptojs-helper';
import { useLaneContext } from '../../context/LaneContext';

const StaticQuickSelect = () => {
  const { screen } = useLaneContext();
  const { userNew } = useAuthContext();
  const decrypted = decrypt(userNew);

  const user = JSON.parse(decrypted);
  const currentClient = user.currentClient.client.name.toLowerCase();

  return (
    <Card style={{ maxWidth: 1340 }}>
      <CardHeader
        disableTypography
        title={
          <Box display='flex' alignItems='center'>
            Static Quick Select
          </Box>
        }
      />
      <Stack direction={'column'} gap={2}>
        <Box display={'grid'} style={{ placeItems: 'center' }}>
          <img
            src={`${process.env.REACT_APP_BUCKET_URL}/${
              process.env.REACT_APP_BUCKET_ENV
            }/lane-management/${currentClient}/${screen}/static/select/1/image.png?${new Date().getTime()}`} // cache breaker
            alt='Quick Select Option One'
            width={'100%'}
          />
        </Box>
      </Stack>
    </Card>
  );
};

export default StaticQuickSelect;
